module.exports = __webpack_public_path__ + "static/WelcomeToElk1-549267c16619d3bde9ac619108c1e36c.png";